import { render } from "./DashboardSvg.vue?vue&type=template&id=23d622f6"
const script = {}
script.render = render

export default script